import styled from 'styled-components';
import { media } from '@carvana/stc-styles';

import { Rule } from '../../../theme/layoutstyles';

const Halo = styled(Rule)`
  background: ${({ theme }) => theme.carvana.yellow.primary};
  margin-top: 30px;
  ${media.sm`
    margin-bottom: 25px;
  `}
`;

export { Halo };
